// extracted by mini-css-extract-plugin
export default {"slider_center":"Slider_slider_center__KfHFS","slider_bg_1":"Slider_slider_bg_1__LmudI","header_con":"Slider_header_con__GYIPT"};